import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { TertiaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

export type NoNumericFieldsArgs = {
  editDataset: OnButtonClick;
  openManageFieldsModal: OnButtonClick;
  showActionControls?: boolean;
  i18nLocale: I18nLocale;
};

export const noNumericFields = ({
  editDataset,
  openManageFieldsModal,
  showActionControls = true,
  i18nLocale,
}: NoNumericFieldsArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noNumericFields.title',
    'No number field in dataset'
  ),
  description: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noNumericFields.description',
    'To use this view style, add a number field to the components in your dataset or edit your dataset.'
  ),
  children: !showActionControls ? null : (
    <>
      <TertiaryButton onClick={openManageFieldsModal}>
        {t(
          i18nLocale,
          'tabview:graphViews.emptyStateLayout.noNumericFields.addField',
          'Add field'
        )}
      </TertiaryButton>
      <TertiaryButton onClick={editDataset}>
        {t(
          i18nLocale,
          'tabview:graphViews.emptyStateLayout.noNumericFields.editDataset',
          'Edit dataset'
        )}
      </TertiaryButton>
    </>
  ),
});
